import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import preloaderVideo from '../../asserts/preloader.mp4';
import './Preloader.css';

const Preloader = ({ onComplete, onUserGesture }) => {
  const containerRef = useRef(null);
  const circleRef = useRef(null);

  useEffect(() => {
    const size = Math.max(window.innerWidth, window.innerHeight) * 3;

    gsap.set(circleRef.current, {
      width: size,
      height: size,
      opacity: 1,
      borderRadius: '50%',
      xPercent: -50,
      yPercent: -50,
    });

    gsap.to(circleRef.current, {
      width: 0,
      height: 0,
      duration: 1,
      ease: 'power3.inOut',
      delay: 0.1,
    });

    const timer = setTimeout(() => {
      gsap.to(containerRef.current, {
        opacity: 0,
        duration: 0.2,
        ease: 'power2.inOut',
        onComplete: () => {
          if (onComplete) onComplete();
        },
      });
    }, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const handleClick = () => {
    if (onUserGesture) onUserGesture();
  };

  return (
    <div
      className="preloader-container"
      ref={containerRef}
      onClick={handleClick}
      onTouchStart={handleClick}
    >
      <video
        className="preloader-video"
        src={preloaderVideo}
        autoPlay
        muted
        playsInline
      />
      <div className="preloader-circle" ref={circleRef} />
    </div>
  );
};

export default Preloader;